const moduleDefinitionActionTypes = {
    SET_FORM_DIRT: "SET_FORM_DIRT",
    SET_CONTROL_FORM_DIRT: "SET_CONTROL_FORM_DIRT",
    RETRIEVED_SOURCE_FOLDERS: "RETRIEVED_SOURCE_FOLDERS",
    RETRIEVED_SOURCE_FILES: "RETRIEVED_SOURCE_FILES",
    RETRIEVED_CONTROL_ICONS: "RETRIEVED_CONTROL_ICONS"
};
export default moduleDefinitionActionTypes;